//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'quality-stats',
  data: function data() {
    return {
      overview: {
        totalQuestions: 1208,
        avgDifficulty: '2.8',
        avgDiscrimination: '0.52',
        cronbachAlpha: '0.83'
      },
      barColors: ['#67C23A', '#409EFF', '#E6A23C', '#F56C6C', '#909399'],
      discColors: ['#F56C6C', '#E6A23C', '#409EFF', '#67C23A'],
      bloomColors: ['#67C23A', '#409EFF', '#E6A23C', '#F56C6C', '#8A6DE9'],
      pieColors: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#8A6DE9', '#909399', '#FF6A5C', '#42B983'],
      difficultyDistribution: [{
        label: '★ (1分)',
        count: 45,
        percent: 4
      }, {
        label: '★★ (2分)',
        count: 280,
        percent: 23
      }, {
        label: '★★★ (3分)',
        count: 520,
        percent: 43
      }, {
        label: '★★★★ (4分)',
        count: 280,
        percent: 23
      }, {
        label: '★★★★★ (5分)',
        count: 83,
        percent: 7
      }],
      discriminationDistribution: [{
        label: '优秀 (≥0.4)',
        count: 480,
        percent: 40
      }, {
        label: '良好 (0.3-0.4)',
        count: 350,
        percent: 29
      }, {
        label: '一般 (0.2-0.3)',
        count: 250,
        percent: 21
      }, {
        label: '需改进 (<0.2)',
        count: 128,
        percent: 10
      }],
      questionTypeIdDistribution: [{
        label: '单选题',
        count: 420
      }, {
        label: '简单情景对话',
        count: 180
      }, {
        label: '丰富情景对话',
        count: 120
      }, {
        label: '翻译题',
        count: 160
      }, {
        label: '造句题',
        count: 150
      }, {
        label: '写作题',
        count: 100
      }, {
        label: '排序题',
        count: 78
      }],
      bloomDistribution: [{
        label: '记忆',
        count: 380,
        percent: 31
      }, {
        label: '理解',
        count: 420,
        percent: 35
      }, {
        label: '应用',
        count: 250,
        percent: 21
      }, {
        label: '分析',
        count: 120,
        percent: 10
      }, {
        label: '创造',
        count: 38,
        percent: 3
      }],
      qualityTrends: [{
        date: '2026-07-24',
        avgDifficulty: '2.8',
        avgDiscrimination: '0.52',
        cronbachAlpha: '0.83',
        expertCvi: '0.88',
        newQuestions: 15
      }, {
        date: '2026-07-23',
        avgDifficulty: '2.7',
        avgDiscrimination: '0.51',
        cronbachAlpha: '0.82',
        expertCvi: '0.87',
        newQuestions: 22
      }, {
        date: '2026-07-22',
        avgDifficulty: '2.8',
        avgDiscrimination: '0.53',
        cronbachAlpha: '0.83',
        expertCvi: '0.88',
        newQuestions: 8
      }, {
        date: '2026-07-21',
        avgDifficulty: '2.7',
        avgDiscrimination: '0.50',
        cronbachAlpha: '0.81',
        expertCvi: '0.86',
        newQuestions: 30
      }, {
        date: '2026-07-20',
        avgDifficulty: '2.6',
        avgDiscrimination: '0.49',
        cronbachAlpha: '0.80',
        expertCvi: '0.85',
        newQuestions: 18
      }]
    };
  }
};